<template>
  <div
    class="bg-main"
    :class="{
      'pt-header-desktop': !hasSiteMessagePadding && !isCheckout && !hasClub,
      'pt-header-desktop-w': hasSiteMessagePadding && !isCheckout && !hasClub,
      'pt-header-desktop-club-selected':
        !hasSiteMessagePadding && !isCheckout && hasClub,
      'pt-header-desktop-w-club-selected':
        hasSiteMessagePadding && !isCheckout && hasClub,
    }"
  >
    <PageHeader
      v-if="!isCheckout"
      class="fixed top-0 right-0 left-0 z-header"
      :scrolled="scrolled"
      :is-checkout="isCheckout"
    />
    <div
      :class="{
        'min-h-screen': !isThankYouPage,
      }"
    >
      <ClubAndSeller v-if="clubCookie && sellerCookie && !isCheckout" />
      <slot />
    </div>
    <ScrollTopComponent :is-mobile="uiStore.isMobile">
      <fa
        class="pointer-events-none text-white text-umd"
        :icon="['fal', 'long-arrow-up']"
      />
    </ScrollTopComponent>
    <PageFooter v-if="!isCheckout" />
  </div>
</template>

<script setup lang="ts">
import PageFooter from '~/components/body/PageFooter.vue';
import { useUiStore } from '~/store/ui';
import { useConfigStore } from '~/store/config';
import ScrollTopComponent from '~/components/body/ScrollTopComponent.vue';
import PageHeader from '~/components/body/PageHeader.vue';

import { useCartStore } from '~/store/cart';
import type { SellerClub, SellerPerson } from '~/constants/types/seller';
import useAlgoliaSearch from '~/composables/useAlgoliaSearch';
import ClubAndSeller from '~/components/body/ClubAndSeller.vue';
const uiStore = useUiStore();
const config = useConfigStore();
const route = useRoute();

const lastPosition = ref(0);
const scrolled = ref(false);
const windowWidth = ref(0);

const fbBackupCookie = useCookie('fbBackupCookie', { path: '/' });
const cartStore = useCartStore();

const scrollBreakpoint = computed<number>(()=> {
  return uiStore.isMobile ? 98 : 128;
});

const isCheckout = computed<boolean>(()=> {
  const thisRoute = config.routeData(route.path);

  if (thisRoute) {
    return thisRoute.template === 'template-checkout';
  } else {
    return false;
  }
});

const isThankYouPage = computed<boolean>(()=> {
  const thisRoute = config.routeData(route.path);
  if (thisRoute) {
    return thisRoute.template === 'template-thank-you-page';
  } else {
    return false;
  }
});

const isProductPage = computed<boolean>(()=> {
  const thisRoute = config.routeData(route.path);
  if (thisRoute) {
    return thisRoute.template === 'produkt';
  } else {
    return false;
  }
});
const isSiteMessageHiddenCookie = useCookie('isSiteMessageHidden', { maxAge: 3600 * 24 * 7, path: '/' });
const hasSiteMessagePadding = computed<boolean>(()=> {
  return (config.siteWideMessage && config.siteWideMessage !== '' && isSiteMessageHiddenCookie.value !== 'true') || config.usps.length > 0;
});

/**
 * @todo - whats going on here
 */
const hasClub = computed<boolean>(()=> {
  return !!clubCookie.value && clubCookie.value.club && clubCookie.value.club.custno !== defaultClubCustNo.value;
});

const defaultClubCustNo = computed<string>(()=> {
  return config.default_club?.custno || '';
});

const handleScroll = () => {
  if (true) {
    if (
      window.scrollY > scrollBreakpoint.value &&
      lastPosition.value < window.scrollY
    ) {
      scrolled.value = true;
    }

    if (window.scrollY < scrollBreakpoint.value) {
      scrolled.value = false;
    }

    lastPosition.value = window.scrollY;
  }
};

onMounted(()=> {
  updateWidth();
  window.addEventListener('resize', updateWidth);

  windowWidth.value = window.innerWidth;
  window.addEventListener('resize', () => {
    windowWidth.value = window.innerWidth;
  });

  window.addEventListener('scroll', () => {
    //handleScroll(.value);
  });

  // If the url contains a facebook id, we store it in our own cookie
  // in case the real facebook cookie is blocked. Used in ThankYouPage.vue
  if (route.query?.fbclid) {
    fbBackupCookie.value = route.query?.fbclid || '';
  }

  try {
    if (!isThankYouPage.value) {
      cartStore.initialCart();
    }
  } catch (e) {
    console.error(e);
  }

  //setSeller();
});

// * * * * * * * * * * * * * * * * * SELLER / CLUB
//if (config.clubCookie && config.sellerCookie) {
//  const clubCookie = config.clubCookie;
//  const sellerCookie = config.sellerCookie;
//  const isSeller = useCookie<boolean>('isSeller', { maxAge: 3600 * 24 * 182, path: '/' });
console.log('club store value: ' + config.clubCookie.Name)  
//} else {
  const { sellerCookieOptions } = useCookieConfig();
  const clubCookie = useCookie<SellerClub>('club', sellerCookieOptions);
  const sellerCookie = useCookie<SellerPerson>('seller', sellerCookieOptions);
  const isSeller = useCookie<boolean>('isSeller', sellerCookieOptions);
//}
const { algoliaClubSearch, algoliaSellerSearch } = useAlgoliaSearch();

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});

const updateWidth = () => {
  uiStore.isMobile = (window.innerWidth < 1024); //
  uiStore.isTabletPortrait = (window.innerWidth > 640 && window.innerWidth < 1024);
};

</script>

<style scoped lang="postcss">
</style>
